import { trackableImageLocalizers, type ScenePlacement } from 'trace-viewer/cms';

/** Choosing a runtime source does not edit primary/enabled or save CMS data. */
export function LocalizerChoice({ placements, selectedId, onChange }: {
    placements: readonly ScenePlacement[];
    selectedId: string;
    onChange: (placementId: string) => void;
}) {
    const eligible = trackableImageLocalizers(placements);
    if (!eligible.length) return null;
    return <label>Marker
        <select aria-label="Marker" value={selectedId} onChange={event => onChange(event.target.value)}>
            <option value="" disabled>Choose a marker</option>
            {eligible.map(p => <option key={p.id} value={p.id}>{p.localizer?.name || p.id}</option>)}
        </select>
    </label>;
}
